import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { uppercaseOnlyFirstLetter } from '../../../utils/formatStrings';
import Table from '../../../components/Table';
import { RemoveItemContent, RemoveUserIcon } from './styles';
import { Icon } from '@gerdau/hefesto';
import RemoveInternalUserModal from './RemoveInternalUserModal';
import { IInternalUser } from '../../../store/ducks/internal-user/types';

interface IInternalUsersTableDataSource {
  key: string;
  name: string;
  email: string;
  salesRepCodes: string;
}

interface IInteralUsersTableProps {
  internalUsers: IInternalUser[];
  setSellerReps: Dispatch<SetStateAction<IInternalUser[]>>;
}

interface IRemoveModalProps {
  id: string;
  name: string;
}

const InternalUsersTable: React.FC<IInteralUsersTableProps> = ({
  internalUsers,
  setSellerReps
}) => {
  const [originalData, setOriginalData] = useState<
    IInternalUsersTableDataSource[]
  >([]);

  const [showDeleteModal, setShowDeleteModal] =
    useState<IRemoveModalProps | null>(null);

  const getColumns = () => {
    return [
      {
        title: 'Nome do usuário',
        dataIndex: 'name',
        sorter: (
          a: IInternalUsersTableDataSource,
          b: IInternalUsersTableDataSource
        ) => a.name.localeCompare(b.name),
        render: (text: string) => (
          <>
            <span>{uppercaseOnlyFirstLetter(text)}</span>
          </>
        )
      },
      {
        title: 'Código do vendedor',
        dataIndex: 'salesRepCodes',
        sorter: (
          a: IInternalUsersTableDataSource,
          b: IInternalUsersTableDataSource
        ) =>
          a.salesRepCodes < b.salesRepCodes
            ? -1
            : a.salesRepCodes > b.salesRepCodes
            ? 1
            : 0,
        render: (text: string) => <>{text}</>
      },
      {
        title: 'E-mail',
        dataIndex: 'email',
        sorter: (
          a: IInternalUsersTableDataSource,
          b: IInternalUsersTableDataSource
        ) => (a.email < b.email ? -1 : a.email > b.email ? 1 : 0),
        render: (text: string) => <>{text}</>
      },
      {
        title: '',
        dataIndex: '',
        width: 20,
        align: 'center' as const,
        render: (data: IInternalUsersTableDataSource) => (
          <RemoveItemContent>
            <RemoveUserIcon
              onClick={() => {
                setShowDeleteModal({ id: data.key, name: data.name });
              }}
            >
              <Icon variant="danger" option="Trash"></Icon>
            </RemoveUserIcon>
          </RemoveItemContent>
        )
      }
    ];
  };

  useEffect(() => {
    const data: IInternalUsersTableDataSource[] = internalUsers.map(
      (internalUser) => {
        return {
          key: internalUser.id,
          email: internalUser.email,
          name: internalUser.name,
          salesRepCodes: internalUser.salesRepCode.join(',')
        };
      }
    );

    setOriginalData(data);
  }, [internalUsers]);

  return (
    <>
      <Table columns={getColumns()} data={originalData} hasPagination />
      {showDeleteModal && (
        <RemoveInternalUserModal
          id={showDeleteModal.id}
          name={showDeleteModal.name}
          onClose={() => setShowDeleteModal(null)}
          setSellerReps={setSellerReps}
        />
      )}
    </>
  );
};

export default InternalUsersTable;
